import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Stack,
  Textarea,
  useDisclosure,
} from "@chakra-ui/react";
import { useRef, useState } from "react";
import { BsFillCameraFill } from "react-icons/bs";
import { ImCamera } from "react-icons/im";
import { TbCameraPlus } from "react-icons/tb";
import { addStory } from "../service";

function CameraStoriesModal({ acctType, reload }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [previewImg, setPreviewImg] = useState("");

  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState("");
  const [color] = useState("#ffffff");
  const [img, setImg] = useState("");
  const imgRef = useRef();

  const handleSendStory = async () => {
    const formData = new FormData();
    formData.append("file", img);
    formData.append("type", "image");
    content && formData.append("text", content);

    setLoading(true);
    await addStory(formData, onClose, setLoading).then(() => reload());
  };

  // convert file to a base64 url

  const readURL = (file) => {
    return new Promise((res, rej) => {
      const reader = new FileReader();
      reader.onload = (e) => res(e.target.result);
      reader.onerror = (e) => rej(e);
      reader.readAsDataURL(file);
    });
  };

  return (
    <>
      <Flex justify={"center"} onClick={onOpen} cursor="pointer" width="100%">
        {" "}
        <ImCamera color="#0276fc" size={22} />
      </Flex>
      <Modal isOpen={isOpen} onClose={onClose} size="sm" isCentered>
        <ModalOverlay />
        <ModalContent height={"500px"}>
          <Stack
            direction={"row"}
            alignItems="center"
            mb="10px"
            p="5px 5px 0 5px"
          >
            <TbCameraPlus
              color="#5353ff"
              style={{ marginLeft: "10px" }}
              fontSize={"2em"}
              cursor={"pointer"}
              onClick={() => imgRef?.current?.click()}
            />
            <input
              style={{ display: "none" }}
              ref={imgRef}
              type={"file"}
              accept="image/jpg, image/jpeg, image/png"
              onChange={async (e) => {
                setImg(e.target.files?.[0]);
                setPreviewImg(await readURL(e.target.files?.[0]));
              }}
            />
          </Stack>

          <ModalCloseButton />
          <ModalBody
            p="20px"
            background={`linear-gradient(90deg, rgb(0 0 0 / 63%) 0%, rgb(0 0 0 / 63%) 51%), url(${previewImg})`}
            borderTopRightRadius={"10px"}
            borderTopLeftRadius={"10px"}
            backgroundSize="cover"
            backgroundRepeat={"no-repeat"}
            h="100%"
          >
            <Flex
              direction={"column"}
              width="100%"
              height="350px"
              justify="center"
              align="center"
            >
              <Textarea
                className="scroll-container"
                color={"#fff"}
                bg="inherit"
                width="100%"
                height="40%"
                textAlign={"center"}
                vertical-align="middle"
                placeholder="Enter your story1"
                _placeholder={{ color: "#d8d8d8" }}
                whiteSpace={"normal"}
                resize="none"
                value={content}
                onChange={(e) => setContent(e.target.value)}
              />
            </Flex>
          </ModalBody>

          <Button
            borderRadius={"none"}
            bg="#5353ff"
            _hover={{ background: "#5353ff" }}
            color="#fff"
            isLoading={loading}
            onClick={handleSendStory}
            isDisabled={!img}
          >
            Done
          </Button>
        </ModalContent>
      </Modal>
    </>
  );
}

export default CameraStoriesModal;
